import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface IndianState {
  code: string;
  name: string;
  name_hi: string | null;
}

export function useIndianStates() {
  return useQuery({
    queryKey: ["indian-states"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("indian_states")
        .select("code, name, name_hi")
        .eq("is_active", true)
        .order("name");
      
      if (error) throw error;
      return data as IndianState[];
    },
    staleTime: 1000 * 60 * 60, // 1 hour - states don't change often
  });
}
